import React from 'react'

import { Heading } from '../../typography'
import CTA from '../../shared/CTA'
import HeroPicture from '../whitepaper/heroPicture'

import { Block, Container, Item, Pair, Text as TextBlock } from '../../../utils'

const StarterHero = ({ title, subtitle, url, alt, label }) => (
    <Container style={{ paddingTop: '4rem' }}>
        <Pair>
            <Item>
                <TextBlock>
                    <Heading size={70} sizeTablet={60} sizeDesktop={70}>
                        {title}
                    </Heading>
                    <Heading size={25} style={{ fontWeight: 'normal' }}>
                        <div>{subtitle}</div>
                    </Heading>
                    <CTA context="starter" labelName={label} />
                </TextBlock>
            </Item>
            <Item>
                <Block>
                    <HeroPicture url={url} alt={alt} />
                </Block>
            </Item>
        </Pair>
    </Container>
)

export default StarterHero
